import InputField, {InputField as InputFieldBase} from './InputField';

export default InputField;
export {InputFieldBase};
